// This icon file is generated automatically.
var PSyncOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M1.63 6.88A5.34 5.34 0 014.9 2.05a5.35 5.35 0 016.32 1.64l-.94.73c-.08.07-.05.2.05.23l2.74.67c.08.02.16-.04.16-.12l.01-2.83c0-.1-.12-.16-.2-.1l-.88.7A6.54 6.54 0 00.44 6.86c0 .07.05.13.12.13h.94c.07 0 .12-.05.13-.12zm11.8.12h-.93a.12.12 0 00-.13.12 5.34 5.34 0 01-3.28 4.83 5.35 5.35 0 01-6.32-1.64l.94-.74a.13.13 0 00-.05-.22L.92 8.68a.13.13 0 00-.16.12l-.01 2.83c0 .1.12.17.2.1l.88-.69a6.55 6.55 0 0011.73-3.91.13.13 0 00-.12-.13z", "fill-rule": "nonzero" } }] }, "name": "p-sync", "theme": "outlined" };
export default PSyncOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PSyncOutlined.js
// module id = 3677
// module chunks = 0